import React from 'react';
import { Button } from '@mui/material';

const defaultSx = {
  borderRadius: "8px",
  color: "#fff",
  padding: "0.4rem 1rem",
  // "&:hover": { background: "rgba(30, 106, 253, 0.8)" },
};

const PrimaryButton = ({
  type = 'button',
  onClick = () => {},
  label = '',
  sx = {},           // استایل‌هایی که از بیرون داده می‌شود
  disabled = false,
  variant = 'contained',
  color = 'primary',
  size = 'large',
  customizedStyle = false,
  ...rest
}) => {

 let combinedSx;
  if (customizedStyle) {
   combinedSx = { ...defaultSx, ...sx };
  }
  else {
   combinedSx = { ...defaultSx};
  }

  return (
    <Button
      {...rest}
      size={size}
      type={type}
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      sx={{...defaultSx, ...sx}}
      color={color}
    >
      {label}
    </Button    >
  );
};

export default PrimaryButton;
